import { ZSLAsset } from "src/components/ZapCard";

export function isZSLAssetWithZdl(
  value: unknown,
): value is ZSLAsset & { zdl: NonNullable<ZSLAsset["zdl"]> } {
  return typeof value === "object" && value !== null && "id" in value;
}
